import { render, staticRenderFns } from "./OrgUserModal.vue?vue&type=template&id=33890de4"
import script from "./OrgUserModal.vue?vue&type=script&lang=js"
export * from "./OrgUserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33890de4')) {
      api.createRecord('33890de4', component.options)
    } else {
      api.reload('33890de4', component.options)
    }
    module.hot.accept("./OrgUserModal.vue?vue&type=template&id=33890de4", function () {
      api.rerender('33890de4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/OrgUserModal.vue"
export default component.exports